<template>
  <li :class="['c-sidenav-menu__item', {'c-sidenav-menu__item--submenu-open': isSubmenuOpen}]">

    <template v-if="menuItem.activeLinks && menuItem.activeLinks.length > 0 && hasSelectedContext(menuItem)">
      <div :id="`${menuItem.identifier}-wrapper`" class="c-sidenav-menu__wrapper" :class="{ 'c-sidenav-menu__wrapper--has-active-submenu': hasActiveSubmenu }" @click="isOpen = !isOpen" @keyup.enter="isOpen = !isOpen" tabindex="0">
        <div class="c-sidenav-menu__icon-wrapper">
          <font-awesome-icon v-if="menuItem.icon" class="c-sidenav-menu__icon" :icon="menuItem.icon"/>
        </div>
        <div class="c-sidenav-menu__text">
          <div class="c-sidenav-menu__text-title">
            {{ menuItem.title }}
          </div>
        </div>
        <font-awesome-icon :class="['c-sidenav-menu__arrow', {'c-sidenav-menu__arrow--rotated': isSubmenuOpen}]" :icon="['fal', 'chevron-down']"/>
      </div>

      <transition-collapse-height>
        <ul class="c-sidenav-menu__sub" v-show="isSubmenuOpen">
          <li class="c-sidenav-menu__item" :key="link.title" v-for="link in menuItem.activeLinks">
            <template v-if="hasSelectedContext(link)">
              <router-link :id="`${link.identifier}-link`" :class="['c-sidenav-menu__wrapper-sub', { 'c-sidenav-menu__wrapper-sub--is-active': isLinkActive(link) }]" :to="getRoute(link)" @click.native="$emit('click')" :title="link.title">
                <div class="c-sidenav-menu__text">
                  <div class="c-sidenav-menu__text-title">
                    {{ link.title }}
                  </div>
                </div>
              </router-link>
            </template>

            <template v-else>
              <div :id="`${link.identifier}-link`" class="c-sidenav-menu__wrapper-sub" @click.stop="onClick(link)" :title="link.title">
                <div class="c-sidenav-menu__text">
                  <div class="c-sidenav-menu__text-title">
                    {{ link.title }}
                  </div>
                  <div class="c-sidenav-menu__text-context-notice">
                    {{ $t('label.select{label}', { label: link.hasSelectedContext.slice(-1) }) }}
                  </div>
                </div>
              </div>
            </template>
          </li>
        </ul>
      </transition-collapse-height>
    </template>

    <template v-else>
      <template v-if="hasSelectedContext(menuItem)">
        <router-link :id="`${menuItem.identifier}-link`" :class="['c-sidenav-menu__wrapper', {'c-sidenav-menu__wrapper--is-active': isLinkActive(menuItem) }]" :to="getRoute(menuItem)" @click.native="$emit('click')" :title="menuItem.title">
          <div class="c-sidenav-menu__icon-wrapper">
            <font-awesome-icon v-if="menuItem.icon" class="c-sidenav-menu__icon" :icon="menuItem.icon"/>
          </div>
          <div class="c-sidenav-menu__text">
            <div class="c-sidenav-menu__text-title">
              {{ menuItem.title }}
            </div>
          </div>
        </router-link>
      </template>

      <template v-else>
        <div :id="`${menuItem.identifier}-link`" class="c-sidenav-menu__wrapper" @click.stop="onClick(menuItem)" :title="menuItem.title">
          <div class="c-sidenav-menu__icon-wrapper">
            <font-awesome-icon v-if="menuItem.icon" class="c-sidenav-menu__icon" :icon="menuItem.icon"/>
          </div>
          <div class="c-sidenav-menu__text">
            <div class="c-sidenav-menu__text-title">
              {{ menuItem.title }}
            </div>
            <div class="c-sidenav-menu__text-context-notice">
              {{ $t('label.select{label}', { label: menuItem.hasSelectedContext.slice(-1) }) }}
            </div>
          </div>
        </div>
      </template>
    </template>
  </li>
</template>

<script>
import { context, menu } from '@/mixins/helpers'

import TransitionCollapseHeight from '@/components/Transitions/TransitionCollapseHeight'

export default {
  name: 'SideNavMenuItem',

  mixins: [ context, menu ],

  components: { TransitionCollapseHeight },

  props: {
    menuItem: {
      validator: menuItem => menuItem.title && typeof menuItem.icon !== 'undefined'
    }
  },

  data () {
    return {
      isOpen: false
    }
  },

  computed: {
    isSubmenuOpen () {
      return this.isOpen || (typeof this.menuItem.activeWhen !== 'undefined' ? this.menuItem.activeWhen.includes(this.$route.name) : false)
    },
    hasActiveSubmenu () {
      return this.menuItem.activeWhen.includes(this.$route.name)
    }
  },

  methods: {
    isLinkActive (link) {
      return typeof link.activeWhen !== 'undefined' ? link.activeWhen.includes(this.$route.name) : false
    },

    hasSelectedContext (link) {
      return typeof link.hasSelectedContext !== 'undefined' ? link.hasSelectedContext.every(key => this.context.isSelected(key)) : true
    },

    getRoute (link) {
      const route = { name: link.routeName }

      if (link.routeParams) {
        Object.assign(route, { params: link.routeParams(this.context) })
      }

      return route
    },

    onClick (link) {
      this.$nextTick(() => {
        this.setContextSelectState({ isActive: true, route: { name: link.routeName, params: link.routeParams || function () { return {} } } })
        this.$store.dispatch('setMinimumSelections', link.hasSelectedContext).then(this.$store.dispatch('resetSelection'))
      })
    }
  }
}
</script>
